// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_bIawB {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._formGroup_g-6vL {
  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));
  --form-group-content-gap: calc(2 * var(--default-grid-baseline));
}
._formGroup_g-6vL._formGroup_noGap_5jDMI {
  --form-group-content-gap: 0;
}
._formGroup__label_X-eCe {
  padding-inline: var(--form-element-label-offset);
  font-size: var(--font-size);
  font-weight: bold;
}
._formGroup__description_-d200 {
  padding-inline: var(--form-element-label-offset);
  color: var(--color-text-maxcontrast);
}
._formGroup__content_3g3SH {
  display: flex;
  flex-direction: column;
  gap: var(--form-group-content-gap);
  margin-block-start: calc(2.5 * var(--default-grid-baseline));
}
._formGroup__content_3g3SH._formGroup__content_only_T1toy {
  margin-block-start: 0;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcFormGroup-uKT9TTrz.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,8FAA8F;EAC9F,gEAAgE;AAClE;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gDAAgD;EAChD,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,gDAAgD;EAChD,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,4DAA4D;AAC9D;AACA;EACE,qBAAqB;AACvB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_bIawB {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._formGroup_g-6vL {\n  --form-element-label-offset: calc(var(--border-radius-element) + var(--default-grid-baseline));\n  --form-group-content-gap: calc(2 * var(--default-grid-baseline));\n}\n._formGroup_g-6vL._formGroup_noGap_5jDMI {\n  --form-group-content-gap: 0;\n}\n._formGroup__label_X-eCe {\n  padding-inline: var(--form-element-label-offset);\n  font-size: var(--font-size);\n  font-weight: bold;\n}\n._formGroup__description_-d200 {\n  padding-inline: var(--form-element-label-offset);\n  color: var(--color-text-maxcontrast);\n}\n._formGroup__content_3g3SH {\n  display: flex;\n  flex-direction: column;\n  gap: var(--form-group-content-gap);\n  margin-block-start: calc(2.5 * var(--default-grid-baseline));\n}\n._formGroup__content_3g3SH._formGroup__content_only_T1toy {\n  margin-block-start: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
